
import React from 'react';
import { ViewMode } from '../types';

interface HeaderProps {
  currentView: ViewMode;
  onNavigate: (view: ViewMode) => void;
}

const Header: React.FC<HeaderProps> = ({ currentView, onNavigate }) => {
  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-white/90 backdrop-blur-md border-b border-slate-100 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div 
            className="flex items-center cursor-pointer group"
            onClick={() => onNavigate(ViewMode.LANDING)}
          >
            <div className="flex mr-3">
               <div className="w-5 h-8 bg-[#2E4A96] rounded-sm"></div>
               <div className="w-5 h-8 bg-[#1CB496] rounded-sm ml-0.5"></div>
            </div>
            <div>
              <div className="flex items-baseline leading-none">
                <span className="text-[#2E4A96] font-bold text-xl tracking-tight">Whitefield</span>
                <span className="text-[#1CB496] font-bold text-xl tracking-tight ml-1">Health</span>
              </div>
              <p className="text-slate-400 text-[9px] uppercase tracking-[0.25em] font-bold mt-0.5">Premium Home Care</p>
            </div>
          </div>

          <nav className="hidden md:flex space-x-8 text-sm font-semibold">
            <button 
              onClick={() => onNavigate(ViewMode.LANDING)}
              className={`transition-colors ${currentView === ViewMode.LANDING ? 'text-[#1CB496]' : 'text-slate-500 hover:text-[#2E4A96]'}`}
            >
              Services
            </button>
            <button 
              onClick={() => onNavigate(ViewMode.SAFETY)}
              className={`transition-colors ${currentView === ViewMode.SAFETY ? 'text-[#1CB496]' : 'text-slate-500 hover:text-[#2E4A96]'}`}
            >
              Safety
            </button>
          </nav>

          <div className="flex items-center">
            <button 
              onClick={() => onNavigate(ViewMode.BOOKING)}
              className="bg-[#2E4A96] hover:bg-[#1e3266] text-white px-7 py-3 rounded-full text-sm font-bold transition-all shadow-lg shadow-blue-900/10"
            >
              Book Concierge
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
